import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterOutlet } from '@angular/router'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MessageComponent } from './components/message/message.component'
import { environment } from '../environments/environment'
import { AccountInfo, AppSettings, BizFrontendApiService, IsEnvironmentService } from '@interserve-corp/angular'
// import { IsbeauthComponent } from './components/isbeauth/isbeauth.component'
// import { AuthService } from './components/isbeauth/auth.service'
import { lastValueFrom } from 'rxjs'
import { AppInfoService } from './services/app-info.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    CommonModule,
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatButtonModule,
    MessageComponent,
    // IsIgxAppHeaderComponent,
    // IsbeauthComponent,
  ],
})
export class AppComponent {
  title = ''
  titleLink = ''
  subTitle = ''
  subTitleLink = ''
  subTitleColor = ''
  environmentKey: 'prod' | 'dev' = environment.environmentCd === 'prod' ? 'prod' : 'dev'
  account: AccountInfo | undefined = undefined
  authEnable = true
  appInitiaLized = false
  constructor(
    private router: Router,
    // private authService: AuthService,
    private bizFrontendApiService: BizFrontendApiService,
    private isEnvironmentService: IsEnvironmentService,
    private appInfoService: AppInfoService,
  ) {}

  ngOnInit(): void {
    // this.authService.accountSource$.subscribe((account) => {
    //   this.authEnable = account ? true : false
    // })
    // this.authService.loginStatusSource$.subscribe((loginStatus) => {
    //   this.authEnable = loginStatus
    // })

    // this.account = this.authService.Account
    // this.authEnable = this.account ? true : false

    const appSettings: AppSettings = {
      appCd: environment.appCd,
      environmentKey: environment.environmentCd as 'dev' | 'prod',
    }
    this.isEnvironmentService.setAppSettings(appSettings)
    this.bizFrontendApiService.initializeApp('welcome').subscribe(async (res) => {
      let initFrontendCd = 'appInitialize'
      if (this.environmentKey === 'dev') {
        initFrontendCd = 'devAppInitialize'
      }

      const appInitialize = await lastValueFrom(
        this.bizFrontendApiService.getAppVersionFrontends(initFrontendCd, environment.appCd),
      )
      // this.appInitiaLize(appInitialize)
      this.appInfoService.AppInitializeInfo = appInitialize
      this.appInitiaLized = true
    })
  }
  // appInitiaLize(appInitialize: any) {
  //   ;({
  //     title: this.title,
  //     titleLink: this.titleLink,
  //     subTitle: this.subTitle,
  //     subTitleLink: this.subTitleLink,
  //     subTitleColor: this.subTitleColor,
  //   } = appInitialize.layout.header)
  // }
  clickSubTitle() {
    this.router.navigate(['welcome'])
  }
  // logout(): void {
  //   this.authService.logout()
  //   location.reload()
  // }
}
